$( document ).ready(function() {

  $('.toggle_popup, .close_popup').click( (evt) => {
    
    if ($('.guide-popup-wrapper').is(":visible")) {
      $('.guide-popup-wrapper').hide();
    } else {
      $('.guide-popup-wrapper').show();
    }
  } );

  $('.product-options__strength').hide();

  $('.product-item').hover( evt => {
      $(evt.currentTarget).find('.product-options__strength').show();
  }, evt => {
      $(evt.currentTarget).find('.product-options__strength').hide();
  } );

  // Add to cart handler for upsell products in cart drawer
  $(document).on('click', '.cart-upsell .edition_quick_add', function(e) {
    e.preventDefault();
    const button = $(this);
    const variantId = button.data('id');
    
    // If product has multiple variants, redirect to product page
    if (!variantId) {
      const productUrl = button.closest('.product-item').find('.product-item__link a').attr('href');
      if (productUrl) {
        window.location.href = productUrl;
      }
      return;
    }
    
    // Show loading state
    button.addClass('working');
    
    // Add to cart via AJAX
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      // Refresh cart drawer content
      return fetch('?section_id=cart-helper');
    })
    .then(response => response.text())
    .then(text => {
      const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
      const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
      const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
      
      const cartItems = document.getElementById('AjaxCartForm');
      cartItems.innerHTML = cartFormInnerHTML;
      cartItems.ajaxifyCartItems();
      
      document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
      window.preloadImages(cartItems);
      
      // Update cart count in header
      const cartCount = sectionInnerHTML.querySelector('#AjaxCartForm [data-cart-count]').textContent;
      document.querySelector('[data-header-cart-count]').textContent = cartCount;
      
      // Remove loading state
      button.removeClass('working');
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      button.removeClass('working');
    });
  });
}); 


